import {FC, useEffect} from 'react'
import {useLocation} from 'react-router'
import clsx from 'clsx'
import {useLayout} from '../core'
import {DrawerComponent} from '../../assets/ts/components'
import {WithChildren} from '_metronic/helpers'
import {DefaultTitle} from './header/page-title/DefaultTitle'
import {PageActions} from './header/page-title/PageActions'
import {useIsDesktop} from './header/page-title/useIsDesktop'

const Content: FC<WithChildren> = ({children}) => {
  const {config, classes} = useLayout()
  const location = useLocation()
  useEffect(() => {
    DrawerComponent.hideAll()
  }, [location])

  const isDesktop = useIsDesktop()
  const titleInHeader = config.app?.header?.default?.content === 'page-title'

  return (
    <div
      id='kt_app_content'
      className={clsx(
        'app-content flex-column-fluid',
        classes.content.join(' '),
        config.app?.content?.class
      )}
    >
      <div
        id='kt_app_content_container'
        className={clsx(
          'app-container',
          classes.contentContainer.join(' '),
          config.app?.content?.container === 'fixed' ? 'container-xxl' : 'container-fluid'
        )}
      >
        {/* The header only has room for the page title and actions from lg up; below that they
            sit here. */}
        {titleInHeader && !isDesktop && (
          <div className='d-flex flex-wrap align-items-center justify-content-between gap-3 mb-5'>
            <DefaultTitle />
            <PageActions />
          </div>
        )}
        {children}
      </div>
    </div>
  )
}

export {Content}
